<p-dialog
  header="Выберите столбцы"
  [modal]="false"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [position]="'bottomright'"
>
  <table-columns-setting
    [allColumns]="allColumns"
    [(selectedColumns)]="selectedColumns"
    (selectedColumnsChange)="selectedColumnsChange.emit($event)"
  ></table-columns-setting>
</p-dialog>
